<template>
  <div>
    <MapLayer name="Stations" pane="stations">
      <StationMarker v-for="{ station } in randomizedStations" :key="`${station.id}-${species.id}`" :station="station" :zoom="zoom" pane="stations" />
    </MapLayer>

    <ExpiringSpeciesMarker v-for="detection in detections" :key="detection.id" ref="marker" :detection="detection" @expire="removeDetection" />
  </div>
</template>

<script>
import ExpiringSpeciesMarker from 'components/markers/ExpiringSpeciesMarker'
import MapLayer from 'components/layers/MapLayer'
import StationMarker from 'components/markers/StationMarker'
import SpeciesStationsQuery from 'queries/SpeciesStations.graphql'

import { shuffle } from 'lodash'

export default {
  props: {
    detections: {
      type: Array,
      default: () => []
    },

    species: {
      type: Object,
      required: true
    },

    zoom: {
      type: Number,
      default: 3
    }
  },

  data () {
    return {
      stations: []
    }
  },

  methods: {
    removeDetection (detection) {
      const index = this.detections.indexOf(detection)
      this.$emit('update:detections', this.detections.splice(index, 1))
    }
  },

  computed: {
    randomizedStations () {
      return shuffle(this.stations)
    }
  },

  apollo: {
    stations: {
      query: SpeciesStationsQuery,

      variables () {
        return {
          speciesId: this.species.id,
          period: { unit: 'month', count: 1 }
        }
      },

      update: data => data.species.stations
    }
  },

  watch: {
    stations (newStations, oldStations) {
      const newStationIds = newStations.map(s => s.id)
      const oldStationIds = oldStations.map(s => s.id)

      if (!newStationIds.every(s => oldStationIds.includes(s))) {
        this.$emit('load', newStations)
      }
    }
  },

  components: {
    ExpiringSpeciesMarker,
    MapLayer,
    StationMarker
  }
}
</script>
